import { TableColumn } from '../../models';
import { ButtonCellComponent, ButtonCellProps } from './button.component';

export class ButtonColumn<I> extends TableColumn<I, ButtonCellProps> {
  readonly component = ButtonCellComponent;
}
